import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions, Grid, Button, Box } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { TextField as TextF } from "formik-material-ui";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import ModalCloseButton from "../../components/UI/ModalCloseButton";
import styles from '../journal/overlay.module.css';
import Alert from "@material-ui/lab/Alert";
import moment from 'moment';
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import { useSelector } from "react-redux";

const CustomColorCheckbox = withStyles({
    root: {
        color: '#23AFC4',
        '&$checked': {
            color: '#23AFC4',
        },
    },
    checked: {},
})((props) => <Checkbox color='default' {...props} />);

export default function AddPrivateNote({ setOpen, open, players_id }) {
    const axiosInstance = useAxiosPrivate()
    const selectedDate = new Date();
    const [checked, setChecked] = React.useState(false);
    const [group_ID, setGroup_ID] = React.useState('');
    const coachName = useSelector((state) => state.auth.name);
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: 'success',
        message: '',
    });
    const handleClose = () => {
        setOpen(false);
        setChecked(false);
    };

    const [initialValues, setInitialValues] = useState({
        title: "",
        note: "",
        is_group_note: false,
        visibility: "private",
        display_date: "",
        reading_time: ""
    });

    let JournalValidationSchema = Yup.object().shape({
        title: Yup.string()
            .required("Title is required.")
            .max(60, "Maximum length for the title is 60."),
        note: Yup.string()
            .required("Note is required.")
            .max(255, "Maximum length for the note is 255."),
    });


    useEffect(() => {
        if (open) {
            loadData();
            const d = new Date();
            const readDate = d.toDateString().split(" ").join(", ") + " " + d.toLocaleTimeString();
            const reading_time = d.toISOString().split("T")[0] + " " + d.toISOString().split("T")[1];
            setInitialValues({
                title: "",
                note: "",
                is_group_note: false,
                visibility: "private",
                display_date: readDate,
                reading_time: reading_time,
            });
        }
        // eslint-disable-next-line
    }, [open]);

    const loadData = async () => {
        try {
            const { data } = await axiosInstance.get("/team/players");
            const group_id = data?.data?.filter((item => item?.user_id === players_id))[0]?.team_id;
            setGroup_ID(group_id)
        } catch (error) {
            console.log(error)
        }
    };

    const submit = async (payload) => {
        setLoading(true);
        const { note, title } = payload;
        const data = {
            reading_time: moment(selectedDate).format('YYYY-MM-DD HH:mm'),
            title,
            note,
            is_group_note: false,
            visibility: !checked ? "private" : "group",
            player_id: players_id,
            group_id: group_ID
        };

        try {
            await axiosInstance.post("/journal/add", data);
            setLoading(false);
            setAlert({
                showAlert: true,
                severity: 'Success',
                message: 'Note saved successfully!',
            });
            setTimeout(() => {
                setAlert({
                    showAlert: false,
                    severity: 'Success',
                    message: 'Note saved successfully!',
                });
                handleClose();
            }, 3000);
        } catch {
            setLoading(false);
            setAlert({
                showAlert: true,
                severity: 'error',
                message: 'Note sending failed!',
            });
            setTimeout(() => {
                setAlert({
                    showAlert: false,
                    severity: 'error',
                    message: 'Note sending failed!',
                });
            }, 5000);
        }
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <Box sx={{ display: "flex", justifyContent: "right", paddingRight: '2rem', paddingTop: '2rem' }}>
                <ModalCloseButton onClick={handleClose} style={{ position: "static" }} />
            </Box>
            <Formik
                initialValues={initialValues}
                onSubmit={submit}
                validationSchema={JournalValidationSchema}
                enableReinitialize
            >
                {({ dirty, isValid, touched, errors, values }) => (
                    <Form style={{ padding: '0 2.5rem 2.5rem 2.5rem', }} readOnly>
                        <DialogContent>
                            <Grid container spacing={2} alignItems="center" justifyContent="flex-start">
                                <Grid item md={3}>
                                    <div style={{ display: 'flex' }}>
                                        <CustomColorCheckbox
                                            style={{
                                                transform: 'scale(0.7)',
                                                padding: 0,
                                            }}
                                            checked={checked} onChange={handleChange}
                                        />
                                        <p className={styles.makePublic}>{"Make this public"}</p>
                                    </div>
                                </Grid>
                                <Grid md={12}>
                                    <Field
                                        name="title"
                                        component={TextF}
                                        label="Add Title"
                                        fullWidth
                                        className={styles.addTitleLabel}
                                    />
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item md={5}>
                                        <p className={styles.dateText}>{moment(selectedDate).format("dddd, MMMM DD, YYYY").toUpperCase()}<span style={{ marginLeft: "2rem" }}>{moment(selectedDate).format("h:mm:ss A")}</span></p>
                                    </Grid>
                                    <Grid item md={7}>
                                        <p className={styles.dateText}>Written by {coachName}</p>
                                    </Grid>
                                </Grid>
                                <Grid md={12}>
                                    <Field
                                        name="note"
                                        component={TextF}
                                        label="Take a note..."
                                        fullWidth
                                        multiline
                                        rows={10}
                                        className={styles.labelText}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="contained"
                                disabled={!isValid || loading}
                                type="submit"
                                style={!isValid || loading ? {
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    fontStyle: 'normal',
                                    width: '136px',
                                    height: '35px',
                                    background: '#0F9BB0',
                                    opacity: 0.5,
                                    borderRadius: '4px',
                                    padding: '10px 20px',
                                    gap: '10px',
                                    color: '#ffffff', textTransform: 'capitalize'
                                } : alert.showAlert ? {
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    fontStyle: 'normal',
                                    width: '136px',
                                    height: '35px',
                                    borderRadius: '4px',
                                    padding: '10px 20px',
                                    gap: '10px',
                                    backgroundColor: "white",
                                    color: "#0F9BB0",
                                    textTransform: "capitalize",
                                    border: "2px solid",
                                    borderColor: "#0F9BB0"
                                } : {
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    fontStyle: 'normal',
                                    width: '136px',
                                    height: '35px',
                                    background: '#23AFC4',
                                    borderRadius: '4px',
                                    padding: '10px 20px',
                                    gap: '10px',
                                    color: '#ffffff', textTransform: 'capitalize'
                                }}
                            >{alert.showAlert ?
                                "Saved" : loading ? "Saving..." : "Save"}
                            </Button>
                        </DialogActions>
                        {alert.showAlert ? (
                            <div style={{ padding: '0.5rem 2rem' }}>
                                <Alert
                                    severity={alert.severity}
                                    onClose={() =>
                                        setAlert({
                                            ...alert,
                                            showAlert: false,
                                        })
                                    }
                                >
                                    {alert.message}
                                </Alert>
                            </div>
                        ) : <p style={{ height: "1.3rem" }}></p>}
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
